import React, { useState, useRef, useEffect } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { addStock, scanProduct, transferStock, vendorList, uploadInvoice } from "../publicationSlice";
import { containsNumber, validateValueWithoutSpace, length_Thirteen, validateIsFileImageType, image_size_5MB } from "../../../Utils/validators";
import moment from "moment";
import barCode from "../../../Assets/Images/icons/barcode.png";
import DeleteIcon from "@mui/icons-material/Delete";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import DateTimePicker from "../../../Component/dateTimePicker";
import { useDebounce } from "../../../Hooks/useDebounce";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";


const DamageIn = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const inputRef = useRef<HTMLInputElement>(null);
  const initialStock = {
    _id: "",
    name: "",
    price: "",
    image: "",
    uniqueNo: "",
    quantity: 0,
    newQuantity: 0,
  };

  const [state, setState] = useState<{
    newQuantity: any;
    barcode: any;
    startDate: any;
    stockData: typeof initialStock[];
    printerList: { _id: string; name: string }[];
    printerName: any;
    totalAmount: any;
    invoiceLink: any;
    selectedInvoice: any;
    invoiceNo: any;
    returnReason: any;
  }>({
    newQuantity: 0,
    barcode: "",
    startDate: moment
      .utc(new Date())
      .utcOffset(330)
      .format("YYYY-MM-DD HH:mm:ss"),
    stockData: [initialStock],
    printerList: [],
    printerName: "",
    totalAmount: "",
    invoiceLink: "",
    selectedInvoice: "",
    invoiceNo: "",
    returnReason: "",
  });
  const [newQuatntity, setNewQuatntity] = useState<any>()
  const debouncedValue = useDebounce(state?.barcode, 300);

  useEffect(() => {
    if (debouncedValue && debouncedValue?.length > 12) {
      const existingStock = state?.stockData?.find(
        (item) => item?.uniqueNo === debouncedValue
      );
      if (existingStock) {
        // dispatch(showErrorSnackbar("Stock already exists"));
        setState((prevState) => ({
          ...prevState,
          barcode: "",
        }));
      } else {
        dispatch(
          scanProduct({
            id: debouncedValue,
            callback: (res: any) => {
              if (res?.data) {
                let newArr = JSON.parse(JSON.stringify(state?.stockData));
                const initialStockIndex = newArr.findIndex(
                  (item: any) => !item._id && !item.uniqueNo
                );
                let initialStockObj = null;
                if (initialStockIndex !== -1) {
                  initialStockObj = newArr.splice(initialStockIndex, 1)[0]; // Remove and store it
                }
                // res?.data ?.forEach((item:any) => {
                const findData = res?.data?.stock?.find(
                  (stockItem: any) => stockItem?.location === "twobrothers-inhouse"
                );

                const isAlreadyPresent = newArr.some(
                  (existingItem: any) => existingItem?.uniqueNo === res?.data?.uniqueNo
                );

                if (!isAlreadyPresent) {
                  newArr.push({
                    _id: res?.data?._id,
                    price: res?.data?.offerPrice,
                    quantity: findData?.quantity
                      ? findData?.quantity
                      : 0,
                    name: res?.data?.name,
                    image: res?.data?.image,
                    uniqueNo: res?.data?.uniqueNo,
                    newQuantity: 0,
                  });
                }
                // });

                if (initialStockObj) {
                  newArr.push(initialStockObj);
                } else {
                  newArr.push({ ...initialStock });
                }
                setState((prevState) => ({
                  ...prevState,
                  stockData: newArr,
                  barcode: "",
                }));
              } else {
                // dispatch(showErrorSnackbar("No book found with this number"));
              }
            },
            errorCallback: () => { },
          })
        );
      }
    }
    dispatch(
      vendorList({
        callback: (res: any) => {
          const newList = res?.data?.map((item: any) => {
            return { _id: item?._id, name: item?.companyName };
          });
          setState((prevState) => ({
            ...prevState,
            printerList: res?.data?.length > 0 ? newList : [],
          }));
        },
        errorCallback: () => { },
      })
    );
  }, [debouncedValue, state?.startDate]);

  const validateArr = () => {
    let disable = false;
    state?.stockData
      ?.filter((item) => item?._id !== "")
      .forEach((itm) => {
        if (Number(itm?.newQuantity) <= 0) disable = true;
      });
    return disable;
  };
  const handleChange = (value: any, index: any) => {
    const newArr = JSON.parse(JSON.stringify(state?.stockData));
    newArr[index].newQuantity = "";
    if (value === "") {
      setState((prevState) => ({
        ...prevState,
        stockData: newArr,
      }));
      return;
    }
    if (value !== "") {
      if (!containsNumber(value)) {
        // dispatch(showErrorSnackbar("Only Numbers are allowed!"));
        return;
      } else if (!validateValueWithoutSpace(value)) {
        // dispatch(showErrorSnackbar(validateIsNumberOnlyErrMsg));
        return;
      }
      else {
        newArr[index].newQuantity = value;
        setState((prevState) => ({
          ...prevState,
          stockData: newArr,
        }));
      }
       

      calculateQuantity(newArr);
      setNewQuatntity(newArr[index].newQuantity)
    }
  }

  const validations = () => {
    const checkStockData = state?.stockData?.filter((item) => item?._id !== "");
    return (
      state?.startDate === "" ||
      checkStockData?.length === 0 ||
      state?.selectedInvoice === "" ||
      state?.selectedInvoice === undefined ||
      validateArr()
    );
  };
  const handleDelete = (index: any) => {
    const newArr = [...state?.stockData];
    if (index > -1) {
      newArr.splice(index, 1);
    }
    setState((prevState) => ({
      ...prevState,
      stockData: newArr,
    }));
    calculateQuantity(newArr);
  };
  const calculateQuantity = (newArr: any) => {
    const num = newArr
      ?.filter((item: any) => item?._id !== "")
      .reduce((acc: any, curr: any) => {
        return (acc += Number(curr?.newQuantity));
      }, 0);
    setState((prevState) => ({
      ...prevState,
      newQuantity: num,
    }));
  };
  // const calculateQuantity = (newArr: any) => {
  //   const num = newArr
  //     ?.filter((item: any) => item?._id !== "")
  //     .reduce((acc: any, curr: any) => {
  //       return (acc += Number(curr?.newQuantity));
  //     }, 0);
  //   updateState({ productQuantity: num });
  // };
  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      barcode: "",
    }));
  };
  const focusBarcodeInput = (e?: any) => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const handelClick = () => {
    focusBarcodeInput();
  };
  const handleChangeBarcode = (e: any) => {
    setState((prevState) => ({
      ...prevState,
      barcode: e.target.value.toUpperCase(),
    }));
  };

  const onChangeTotalAmount = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        // dispatch(showErrorSnackbar("Only Numbers are allowed!"));
        return;
      } else if (!validateValueWithoutSpace(value)) {
        // dispatch(showErrorSnackbar(validateIsNumberOnlyErrMsg));
        return;
      } else setState((prevState) => ({ ...prevState, totalAmount: value }));
    }
  };
  const handleChangeInvoice = (e: any) => {
    e.preventDefault();
    // if (!validateIsFileImageType(e)) {
    //    dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
    //   return;
    // }
    // if (e.target.files[0]?.size > image_size_5MB) {
    //   dispatch(showErrorSnackbar("Image size should be less than 5 MB!!!"));
    // } else {
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      dispatch(
        uploadInvoice({
          params: file,
          callback: (res: any) => {
            if (res) {
              setState((prevState: any) => ({
                ...prevState,
                selectedInvoice: reader.result,
                invoiceLink: res?.data?.name,
              }));
              dispatch(showSnackbar({ message: res?.status, type: res?.status }));
              setTimeout(() => {
                dispatch(hideSnackbar());
              }, 5000);
            }
          },
          errorCallback: (error: any) => {
            dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          },
        })
      );
    };
    reader.readAsDataURL(file);
    // }
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const {
      newQuantity,
      printerName,
      totalAmount,
      invoiceLink,
      startDate,
      stockData,
      selectedInvoice,
      invoiceNo
    } = state;
    const newBookArr = stockData
      ?.filter((item) => item?._id !== "")
      ?.map((item) => {
        return {
          productId: item?._id,
          quantity: Number(item?.newQuantity),
        };
      });
    const reqBody = {
      totalCount: stockData.reduce((acc, item) => acc + Number(item.newQuantity || 0), 0),
      venderId: printerName?._id,
      totalAmount: Number(totalAmount),
      addedDate: startDate,
      status: 2,
      file: state?.invoiceLink,
      products: newBookArr,
      invoiceNo: invoiceNo,
      from: "twobrothers-inhouse",
      to: "damage-inhouse",
      remark: state?.returnReason,
    };
    if (invoiceLink) reqBody.file = state?.invoiceLink;

    const clearState = {
      newQuantity: 0,
      barcode: "",
      startDate: moment
        .utc(new Date())
        .utcOffset(330)
        .format("YYYY-MM-DD HH:mm:ss"),
      stockData: [
        {
          _id: "",
          name: "",
          price: "",
          image: "",
          uniqueNo: "",
          quantity: 0,
          newQuantity: 0,
        },
      ],
      printerList: [],
      printerName: "",
      totalAmount: "",
      invoiceLink: "",
      selectedInvoice: "",
      invoiceNo: "",
      returnReason: "",
    };
    dispatch(
      transferStock({
        params: reqBody,
        callback: (res: any) => {
          if (res?.status === "success") {
            setState(clearState);
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          console.error(error);
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };
  const renderTable = () => {
    return (
      <div className="admin-table table-responsive">
        <table className="table table-striped table-hover align-middle text-md-start text-center">
          <thead>
            <tr>
              <th>Product Image</th>
              <th>Product Name</th>
              <th>Price</th>
              <th>Old Quantity</th>
              <th>Damage Quantity</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {state?.stockData?.map((item, index) => {
              if (item?._id) {
                return (
                  <tr
                    key={index}
                  >
                    <td>
                      <img
                        src={item?.image}
                        alt="coverImage"
                        style={{ height: "50px", width: "60px" }}
                      />
                    </td>
                    <td className="col-md-3">{item?.name}</td>
                    <td>
                      <InputField
                        placeholder={"₹"}
                        disabled
                        value={item?.price}
                      />
                    </td>
                    <td>
                      <InputField
                        placeholder={"₹"}
                        disabled
                        value={item?.quantity}
                      />
                    </td>
                    <td>
                      <InputField
                        placeholder={"Enter Quantity"}
                        value={item?.newQuantity}
                        setInputText={(val: any) => handleChange(val, index)}
                      />
                    </td>
                    <td>
                      <ClearOutlinedIcon
                        className="colorPurple cursor"
                        fontSize="small"
                        onClick={() => {
                          handleDelete(index);
                        }}
                      />
                    </td>
                  </tr>
                );
              } else {
                return (
                  <td className="d-flex my-3">
                    <input
                      className="form-control w-50"
                      type="text"
                      ref={inputRef}
                      value={state?.barcode}
                      placeholder=""
                      maxLength={length_Thirteen - 1}
                      onChange={handleChangeBarcode}
                    />
                    <span className="text-dark d-flex">
                      <DeleteIcon
                        className="cursor"
                        color="error"
                        fontSize="small"
                        onClick={() => handleClose()}
                      />
                    </span>
                  </td>
                );
              }
            })}
          </tbody>
        </table>
      </div>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Damage In"}
          breadCrumb={""}
          isEditMode={""}
          cancelEdit={() => ""}
        />
      </div>
      <div className="formDiv">
        <div className="col-md-3 mb-3">
          <LabelInput labelName={"Scan QR Code"} />
          <div className="bxshadow p-2 borderRadius text-center cursor col-3" onClick={handelClick}>
            <img src={barCode} alt="QR Code" width={30} />
          </div>
        </div>
        <div className="bxshadow p-2 borderRadius mb-4">
          {renderTable()}
        </div>

        <div className="bxshadow p-2 borderRadius mb-4">
          {/* <div className="row d-flex justify-content-between bxshadow  p-3"> */}
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Total Quantity"} />
                <InputField
                  placeholder={"Total Quantity"}
                  value={state?.newQuantity}
                  disabled
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Invoice No:"} />
                <InputField
                  placeholder="Invoice No:"
                  value={state?.invoiceNo}
                  setInputText={(val: any) =>
                    setState((prevState) => ({
                      ...prevState,
                      invoiceNo: val,
                    }))
                  }
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Date"} />
                <DateTimePicker
                  value={state?.startDate}
                  setInputText={(value: any) =>
                    setState((prevState) => ({
                      ...prevState,
                      startDate: value,
                    }))
                  }
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Remark"} />
                <textarea className="form-control"
                  rows={3}
                  name="returnReason"
                  value={state?.returnReason}
                  onChange={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      returnReason: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Invoice Image"} />
                <ImagePickerAndViewer
                  value={state?.selectedInvoice}
                  handleChange={(e: any) => handleChangeInvoice(e)}
                  htmlFor={"pdf-upload-1"}
                  doctype={"pdf/image"} />
              </div>
            </div>
            <div className="col-md-2 my-4 mx-auto">
              <Submitbtn
                name={"Save and Update Stock"}
                disabled={validations()}
              />
            </div>
          </form>
          {/* </div> */}
        </div>
        {/* </div> */}

      </div>
    </div>
  );
};

export default DamageIn;
